import { Injectable } from '@angular/core';
import { Product } from '../_model/product.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Utils } from '../../../_helpers/utils';


const url = environment.api;


@Injectable({
  providedIn: 'root'
})
export class ProductService {

  product: Product = new Product();
  products: Product[] = [];

  constructor(private http: HttpClient) { }

  getProducts(limit: number, ordersCount: "ASC" | "DESC") {
    return this.http.get<Product[]>(url + 'product', { params: Utils.httpParams({ limit, ordersCount }) });
  }

  getProduct(productId: number) {
    return this.http.get<Product>(url + 'product/' + productId);
  }

  getProductByProvider(providerId: number) {
    return this.http.get(url + 'product?idCompanyProvider=' + providerId);
  }

  createProduct(formData: any) {
    return this.http.post(url + 'product', formData);
  }

  deleteProduct(productId: number) {
    return this.http.delete(url + 'product/' + productId);
  }

  updateProduct(formData: any) {
    return this.http.put(url + 'product/' + this.product.id, formData);
  }

  findProduct(productId: number) {
    return this.products.find(a => a.id === Number(productId));
  }




}
